import { Location } from '@angular/common';
import { Component, inject } from '@angular/core';

@Component({
  selector: 'app-page-not-found',
  template: `
    <div class="w-full max-w-7xl items-center">
      <section class="mt- mb-8 flex lg:mb-0">
        <div
          class="w-full max-w-xl rounded-xl bg-white p-8 text-black shadow-lg md:p-10"
        >
          <!-- Comcast Business | Nitel Logo -->
          <div class="flex items-center justify-center">
            <a routerLink="/" class="inline-block" title="Go to homepage">
              <img
                src="assets/images/logos/comcast_bussiness_nitel_logo.png"
                alt="Comcast Business | Nitel Logo"
                class="h-24 w-auto lg:h-28"
              />
            </a>
          </div>
          <h2
            class="mt-4 font-montserrat text-2xl font-bold text-black lg:text-3xl"
          >
            Page Not Found
          </h2>
          <p class="mt-4 text-lg">This is not the page you were looking for!</p>
          <div class="mt-6 flex">
            <button
              type="button"
              (click)="goBack()"
              title="Go back"
              class="btn-primary"
            >
              Go back
            </button>
          </div>
        </div>
      </section>
    </div>
  `,
  standalone: false,
})
export class PageNotFoundComponent {
  private location = inject(Location);

  goBack(): void {
    this.location.back();
  }
}
